<template>
  <div class="monthly-report">
    <div ref="chart" :style="{ width: '100%', height: height + 'px' }"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  name: 'reportEcharts',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    unit: {
      type: String,
      default: ''
    },
    yAxis: {
      type: String,
      default: '数量'
    },
    title: {
      type: String,
      default: ''
    },
    height: {
      type: [String, Number],
      default: 400
    },
    color: {
      type: String,
      default: '#5470c6'
    }
  },
  created() {},
  mounted() {
    this.initChart()
  },
  data() {
    return {
      chart: null
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chart)
      this.updateChart()
    },
    updateChart() {
      const option = {
        title: {
          text: this.title,
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br/>{a}: {c} ' + this.unit
        },
        legend: {
          data: [this.title],
          bottom: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.data.map(item => item.month),
          axisLabel: {
            rotate: 45 // 避免标签重叠
          }
        },
        yAxis: {
          type: 'value',
          name: this.yAxis,
          min: 0,
          max: 250,
          interval: 50
        },
        series: [
          {
            name: this.title,
            type: 'bar',
            data: this.data.map(item => item.value),
            itemStyle: {
              color: this.color
            },
            label: {
              show: true,
              position: 'top'
            }
          }
        ]
      }
      this.chart.setOption(option)
    }
  }
}
</script>
<style scoped>
.monthly-report {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
</style>
